import React from "react";
import config from "../../config/config";

function QRCodeError() {
  return (
    <>
      <div className="App">
        <div className="qr-before-body w-100">
          <div className="inner-div main-div position-absolute w-100">
            <div className="pt-1 mt-5 d-flex justify-content-center align-items-center flex-column">
              <span className="qr-time-out-text text-danger">TIMEOUT</span>
              <img
                src={`/assets/commonImages/${config?.qr_code_error}.png`}
                alt=""
                className="mt-1"
              />
            </div>
            <div className="d-grid">
              <label className="mt-4 qr-desc  text-center ms-5 me-5">
                Oh no! Your QR Code is invalid.
              </label>
              <label className="mt-3 qr-aprroach text-center ms-5 me-5">
                Please approach the cashier for a new QR Code.
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default QRCodeError;
